export const TransactionType = {
  BusinessCard: "business_card",
  Clawback: "clawback",
  CompanyDebit: "company_debit",
  DirectPay: "direct_pay",
  EwaTransaction: "ewa_transaction",
  InvoiceBankTransfer: "invoice_bank_transfer",
  NetPayCredit: "net_pay_credit",
  Payout: "payout",
  Refund: "refund",
  Topup: "topup",
  WalletTransaction: "wallet_transaction",
} as const;
export type TransactionType =
  (typeof TransactionType)[keyof typeof TransactionType];
